module.exports = __webpack_public_path__ + "img/Transparant.403bb685.png";